/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateProjectRequest
 */
export interface ValidateProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateProjectRequest
     */
    adminComment?: string;
}

/**
 * Check if a given object implements the ValidateProjectRequest interface.
 */
export function instanceOfValidateProjectRequest(value: object): value is ValidateProjectRequest {
    return true;
}

export function ValidateProjectRequestFromJSON(json: any): ValidateProjectRequest {
    return ValidateProjectRequestFromJSONTyped(json, false);
}

export function ValidateProjectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateProjectRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'adminComment': json['adminComment'] == null ? undefined : json['adminComment'],
    };
}

export function ValidateProjectRequestToJSON(value?: ValidateProjectRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'adminComment': value['adminComment'],
    };
}

